export default __webpack_public_path__ + "static/media/daschboardIcon.c5ab64fe.svg";